<template>
  <div class="OceanMap">
    <div class="top"></div>
    <div class="top-right"></div>
    <div class="right-bigfloat">
      <button class="bigfolat flexbox" :style="{ backgroundColor: n.bgcolor }" v-for="(n, index) in bigFloat" :key="index" @click="isShowData(n)">
        <div
          class="icon"
          :style="{
            backgroundImage: 'url(' + n.icon + ')',
          }"
        ></div>
        <div class="text">{{ n.name }}</div>
      </button>
    </div>
    <div class="float-type">
      <div class="type">浮标类型</div>
      <button
        class="typeButton flexbox"
        :style="{
          border: n.num + ' solid #0091ff',
        }"
        v-for="n in folatType"
        :key="n.id"
        @click="selectType(n)"
      >
        <div
          class="icon"
          :style="{
            backgroundImage: 'url(' + n.icon + ')',
            backgroundRepeat: 'no-repeat',
          }"
        ></div>
        <div class="text">{{ n.name }}</div>
      </button>
    </div>
    <div class="leftData flexbox" v-if="selectOneDeatil">
      <div class="icon"></div>
      <div class="shu"></div>
      <div class="shijian">时间：</div>
      <div class="sj-text" v-if="selectOneDeatil.length > 0 && selectOneDeatil[0].createtime">{{ selectOneDeatil[0].createtime }}</div>
      <div class="fengsu">风速：</div>
      <div class="fs-text" v-if="selectOneDeatil.length > 0 && selectOneDeatil[0].col13">{{ Number(selectOneDeatil[0].col13).toFixed(2) }}m/s</div>
      <div class="fengxiang">风向：</div>
      <div class="fx-text" v-if="selectOneDeatil.length > 0 && selectOneDeatil[0].col12">{{ Number(selectOneDeatil[0].col12).toFixed(2) }}°</div>
      <div class="bogao">波高：</div>
      <div class="bg-text" v-if="selectOneDeatil.length > 0 && selectOneDeatil[0].col4">{{ Number(selectOneDeatil[0].col4).toFixed(2) }}m</div>
      <div class="bozhouqi">波周期：</div>
      <div class="bzq-text" v-if="selectOneDeatil.length > 0 && selectOneDeatil[0].col5">{{ Number(selectOneDeatil[0].col5).toFixed(2) }}s</div>
      <div class="boxiang">波向：</div>
      <div class="bx-text" v-if="selectOneDeatil.length > 0 && selectOneDeatil[0].col10">{{ Number(selectOneDeatil[0].col10).toFixed(2) }}°</div>
    </div>
    <div class="bottom-table" v-if="equipinfoList">
      <div class="tableTop flexbox">
        <div class="maxWind24">
          <div class="text1">24h最大</div>
          <div class="text2">风速</div>
        </div>
        <div class="maxWind">
          <div class="text">最大风速</div>
          <div class="number" v-if="equipinfoList.length > 0 && equipinfoList[0].info.col13">
            {{ Number(equipinfoList[0].info.col13).toFixed(2) }}m/s
          </div>
        </div>
        <div class="maxFengxiang">
          <div class="text">最大风向</div>
          <div class="number" v-if="equipinfoList.length > 0 && equipinfoList[0].info.col12">
            {{ Number(equipinfoList[0].info.col12).toFixed(1) }}°
          </div>
        </div>
        <div class="maxBogao24">
          <div class="text1">24h最大</div>
          <div class="text2">风速</div>
        </div>
        <div class="maxBogao">
          <div class="text">最大波高</div>
          <div class="number" v-if="equipinfoList.length > 0 && equipinfoList[0].info.col4">{{ Number(equipinfoList[0].info.col4).toFixed(2) }}m</div>
        </div>
        <div class="bozhouqi">
          <div class="text">波周期</div>
          <div class="number" v-if="equipinfoList.length > 0 && equipinfoList[0].info.col7">{{ Number(equipinfoList[0].info.col7).toFixed(2) }}s</div>
        </div>
        <div class="boxiang">
          <div class="text">波向</div>
          <div class="number" v-if="equipinfoList.length > 0 && equipinfoList[0].info.col10">
            {{ Number(equipinfoList[0].info.col10).toFixed(2) }}°
          </div>
        </div>
        <div class="time">
          <div class="text">时间</div>
          <div class="number" v-if="equipinfoList.length > 0 && equipinfoList[0].info.createtime">{{ equipinfoList[0].info.createtime }}</div>
        </div>
      </div>
      <div class="allData">
        <div>
          <table class="table" style="display: table-cell">
            <tr class="title">
              <td width="50" align="center">最新</td>
              <td width="120" align="center">时间</td>
              <td width="80" align="center">经度</td>
              <td width="80" align="center">纬度</td>
              <td width="100" align="center" v-for="tnm in equipHead.tp" :key="tnm.tnm">{{ tnm.tnm }}</td>
            </tr>
            <tr class="data" v-for="(n, index) in equipinfoList" :key="n + index">
              <td align="center">{{ index + 1 }}</td>
              <td align="center">
                {{ n.info.createtime }}
              </td>
              <td align="center">
                {{ n.info.jdt }}
              </td>
              <td align="center">
                {{ n.info.wdt }}
              </td>
              <td align="center" v-for="(k, index) in n.list" :key="index">
                {{ k }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <modal name="example" :shiftX="1" :shiftY="1" :focusTrap="false">
      <iframe :src="equipId" frameborder="0" width="100%" height="100%"></iframe>
    </modal>
    <div id="container" style="width: 100%; height: 100%"></div>
  </div>
</template>
<script>
//import '../utils/resize'
import bolang from '../assets/images/icon-bolang.png'
import biaomian from '../assets/images/icon-biaomian.png'
import xiaoxing from '../assets/images/icon-xiaoxing.png'
import zhongxing from '../assets/images/icon-zhongxing.png'
import yali from '../assets/images/icon-yali.png'
import yandu from '../assets/images/icon-yandu.png'
import blue from '../assets/images/bg-title-n.png'
import white from '../assets/images/bg-title-p.png'
// import jidi from '../assets/images/icon-shuju.png'

import { myequips, equiphistory, equipinfo } from '../service/getData'
import moment from 'moment'
// import demo from './demo'
let demo = ''
// 信息窗
var infoWindow = null
// 折线
//var polyline = null
var satelliteLayer = new AMap.TileLayer.Satellite()
export default {
  data() {
    return {
      map: null,
      bigFloat: [
        {
          bgcolor: '#1d1e3c',
          name: '宁德-998',
          icon: blue,
        },
        {
          bgcolor: '#1d1e3c',
          name: '汕尾-999',
          icon: blue,
        },
        {
          bgcolor: '#1d1e3c',
          name: '表漂-232',
          icon: blue,
        },
        {
          bgcolor: '#1d1e3c',
          name: '表漂-233',
          icon: blue,
        },
        {
          bgcolor: '#1d1e3c',
          name: '波浪浮标-166',
          icon: blue,
        },
        {
          bgcolor: '#1d1e3c',
          name: '波浪浮标-167',
          icon: blue,
        },
        {
          bgcolor: '#1d1e3c',
          name: '表漂-311-A',
          icon: blue,
        },
        {
          bgcolor: '#1d1e3c',
          name: '表漂-312-A',
          icon: blue,
        },
      ],
      folatType: [
        { icon: bolang, name: '波浪精灵', num: '0px' },
        { icon: biaomian, name: '表面漂流浮标', num: '0px' },
        { icon: xiaoxing, name: '小型综合观测浮标', num: '0px' },
        { icon: zhongxing, name: '中型综合观测浮标', num: '0px' },
        { icon: yali, name: '表面漂流浮标（带压力)', num: '0px' },
        { icon: yandu, name: '表面漂流浮标（带盐度)', num: '0px' },
        // { icon: jidi, name: '极地波浪精灵', num: '0px' },
      ],
      //所有的设备未分类
      allMyequipsData: '',
      //按照类型分类的设备
      groupArr: [],
      //选中的设备
      selectEquip: '',
      selectEquipDeatil: '',
      //将数值对应起来
      equipHead: '',
      excelData: '',
      equipinfoList: '',
      //点标记
      markers: [],
      //坐标点
      listPoint: null,
      // 坐标点对应的设备列表
      listPointEquips: null,
      deviceList: [],
      equipId: '',
      //左下方展示信息
      selectOne: false,
      selectOneDeatil: '',
    }
  },
  methods: {
    getIconPath(type) {
      if (type.includes('波浪精灵') || type.includes('波浪浮标')) {
        return {
          icon: bolang,
        }
      } else if (type.includes('表面漂流浮标') || type === '表面漂流浮标') {
        return {
          icon: biaomian,
        }
      } else if (type.includes('小型综合观测浮标') || type === '小型综合观测浮标') {
        return {
          icon: xiaoxing,
        }
      } else if (type.includes('中型综合观测浮标') || type === '中型综合观测浮标') {
        return {
          icon: zhongxing,
        }
      } else if (type.includes('表面漂流浮标(带压力)') || type === '表面漂流浮标(带压力)') {
        return {
          icon: yali,
        }
      } else if (type.includes('表面漂流浮标(带盐度)') || type === '表面漂流浮标(带盐度)') {
        return {
          icon: yandu,
        }
      } 
      // else if (type.includes('极地波浪精灵')|| type === '极地波浪精灵') {
      //   return {
      //     icon: true,
      //   }
      // }
         else {
        return {
          icon: ''
        }
      }
    },
    //获取所有设备
    async allMyequips() {
      let result = await myequips()
      this.allMyequipsData = result.data
      let type = []
      this.allMyequipsData.map((n) => {
        if (!type.includes(n.equiptypeid)) {
          type.push(n.equiptypeid)
        }
      })
      //将设备分类
      let groupArr = []
      for (let i = 0; i < type.length; i++) {
        this.allMyequipsData.map((n) => {
          if (n.equiptypeid == type[i]) {
            if (!groupArr[i]) {
              groupArr[i] = {
                name: n.equiptypenm,
                items: [],
              }
            }
            groupArr[i].items.push(n)
          }
        })
      }
      this.groupArr = groupArr
      this.listPoint = [] //列表的坐标点
      this.listPointEquips = [] //列表的坐标点
      //手动将表漂232、233修改经纬度
      let demos = demo.split('|')
      let itemspoint = []
      demos.forEach((item) => {
        let items = item.split(',')
        let obj = {
          id: items[0],
          jd: items[1],
          jdchar: items[2],
          wd: items[3],
          wdchar: items[4],
        }
        itemspoint.push(obj)
      })
      this.deviceList = this.allMyequipsData.filter((item) => {
        if (+item.jd === 1 || +item.jd === 0 || +item.wd === 1 || +item.wd === 0) {
          let demo = itemspoint.find((n) => n.id == item.id)
          if (demo) {
            Object.assign(item, demo)
            // console.log('>>>>>>>>>>>>>>>>', item, demo)
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      })
      this.deviceList.map((item) => {
        let arr = []
        arr.push(`${(item.jdchar === 'W' && '-') || ''}${item.jd}`)
        arr.push(`${(item.wdchar === 'S' && '-') || ''}${item.wd}`)

        let LngLat, jd, wd
        jd = item.jd
        wd = item.wd
        if (item.jdchar === 'W') {
          jd = 360 - item.jd
        }
        if (item.wdchar === 'S') {
          wd = -item.wd
        }
        LngLat = new AMap.LngLat(jd, wd, true)
        // 添加折线路径
        this.listPoint.push(LngLat)
        this.listPointEquips.push(item)
      })

      //测试
      //绘制地图
      this.map = new AMap.Map('container', {
        //layers: [new AMap.TileLayer.Satellite()],
        zoom: 5,
        zooms: [3, 18],
        resizeEnable: true,
        features: ['bg', 'road', 'building', 'point'],
        expandZoomRange: true,
        center: [167.39, 30.9],
        // mapStyle: 'amap://styles/darkblue',
      })
      this.map.add(satelliteLayer)
      // 创建折线实例
      //   polyline = new AMap.Polyline({
      //     path: this.listPoint,
      //     borderWeight: 1, // 线条宽度，默认为 1
      //     strokeColor: 'white', // 线条颜色
      //     lineJoin: 'round', // 折线拐点连接处样式
      //   })

      //this.map.add(polyline)
      this.listPoint.map((point, index) => {
        this.addMarker(point, index)
      })

      this.map.add(this.markers)
      //默认第一条数据
      this.isShowData(this.bigFloat[0])
    },
    //点击设备查看详细信息
    async isShowData(n) {
      for (let i = 0; i < this.bigFloat.length; i++) {
        if (n.name == this.bigFloat[i].name) {
          Object.assign(this.bigFloat[i], {
            bgcolor: 'rgba(0, 145, 255, 1)',
            icon: white,
          })
        } else {
          Object.assign(this.bigFloat[i], {
            bgcolor: '#1d1e3c',
            icon: blue,
          })
        }
      }
      this.allMyequipsData.some((item) => {
        if (item.equipmentnm == n.name) {
          this.selectEquip = item
          return true
        }
      })
      setTimeout(() => {
        this.selectEquiphistory()
      }, 200)
    },
    async selectEquiphistory() {
      let loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      if (this.selectEquip.equipid == '37' || this.selectEquip.equipid == '38') {
        let dbt = moment().subtract(2, 'year').format('YYYY-MM-DD')
        let edt = moment().format('YYYY-MM-DD')
        let result = await equiphistory(dbt, edt, this.selectEquip.equipid, 1, 200)
        this.selectEquipDeatil = result.data.total ? JSON.parse(result.data.data) : null
        loading.close()
      } else {
        let dbt = moment().subtract(6, 'months').format('YYYY-MM-DD')
        let edt = moment().format('YYYY-MM-DD')
        let result = await equiphistory(dbt, edt, this.selectEquip.equipid, 1, 200)
        this.selectEquipDeatil = result.data.total ? JSON.parse(result.data.data) : null
        loading.close()
      }

      //经纬度波高等表头
      let result1 = await equipinfo(this.selectEquip.equipid)
      this.equipHead = result1.data
      let excelData = {
        filed: {},
        data: [],
      }
      excelData.filed['"时间"'] = 'createtime'
      excelData.filed['"经度"'] = 'z'
      excelData.filed['"纬度"'] = 'wd'

      this.equipHead.tp &&
        this.equipHead.tp.map((n, index) => {
          excelData.filed[`"${n.tnm}"`] = `col${index}`
        })
      this.excelData = excelData
      this.equipinfoList = []
      this.selectEquipDeatil &&
        this.selectEquipDeatil.map((item) => {
          let obj = []
          let temp = {}
          for (let i = 0; i < this.equipHead.tp.length; i++) {
            obj.push(item['col' + i])
          }
          // obj.push(0)
          // equipinfoList.push(obj)
          temp['info'] = item
          temp['list'] = obj

          this.equipinfoList.push(temp)
        })
      this.equipinfoList.reverse()
    },
    //选择设备类型
    async selectType(n) {
      for (let i = 0; i < this.folatType.length; i++) {
        if (n.name == this.folatType[i].name) {
          Object.assign(this.folatType[i], {
            num: '1px',
          })
        } else {
          Object.assign(this.folatType[i], {
            num: '0px',
          })
        }
      }
    },
    markerClick(e, _this) {
      infoWindow.setContent(e.target.content)
      infoWindow.open(_this.map, e.target.getPosition())
    },
    //标记点
    addMarker(point, i) {
      const icon = this.getIconPath(this.listPointEquips[i].equiptypenm)
      if (!icon) return
      let marker = new AMap.Marker({
        ...icon,
        position: point,
        offset: new AMap.Pixel(0, 0),
        title: `${this.deviceList[i].equipmentnm}`,
      })
      // let equipname = this.info.enm
      // let contentHTML = `<div>设备名称：${equipname}</div>`

      let contentHTML = `<div>设备名称：${this.deviceList[i].equipmentnm}</div><div>经度：${this.deviceList[i].jd}</div><div>纬度：${this.deviceList[i].wd}</div>`
      marker.content = contentHTML
      // 增加label值
      // marker.setLabel({
      //   content: `<div class='info'>${this.deviceList[i].equipmentno}</div>`, //设置文本标注内容
      //   direction: 'bottom' //设置文本标注方位
      // })
      marker.equipid = this.deviceList[i].equipid
      marker.on('click', (e) => this.markerClick(e, this))
      // marker.emit('click', {
      //   target: marker,
      // })
      let _this = this
      AMap.event.addListener(marker, 'click', function (e) {
        _this.showDetail(e.target.equipid)
      })
      this.markers.push(marker)
    },
    async showDetail(e) {
      this.equipId = '/#/mapFrame/' + e
      setTimeout(() => {
        this.$modal.show('example')
      }, 200)
      //获取选中的标记的详细信息
      let dbt = moment().subtract(6, 'months').format('YYYY-MM-DD')
      let edt = moment().format('YYYY-MM-DD')
      let result = await equiphistory(dbt, edt, e, 1, 200)
      this.selectOneDeatil = result.data.total ? JSON.parse(result.data.data) : null
      if (this.selectOneDeatil) {
        this.selectOneDeatil.reverse()
      }
    },
  },
  mounted() {
    //
    //this.map.add(this.markers)
    infoWindow = new AMap.InfoWindow({
      offset: new AMap.Pixel(0, 0),
    })
    this.allMyequips()
  },
}
</script>
<style lang="scss" scoped>
// ::v-deep .amap-layers {
// .amap-satellite {
// filter: brightness(0.1) !important;
// }
// }
::v-deep .amap-info-contentContainer {
  .amap-info-content {
    position: relative;
    background: #383a49;
    padding: 10px 18px 10px 10px;
    line-height: 1.4;
    overflow: auto;
    border: 1px solid #285e9c;
    border-radius: 8px;
    color: white;
  }
}
::v-deep .bottom-center .amap-info-sharp {
  bottom: 0;
  left: 50%;
  margin-left: -8px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #313744;
}
.flexbox {
  display: flex;
}
.OceanMap {
  width: 1920px;
  height: 1080px;
  //background: #06071b;
  //box-shadow: 0px 0px 240px 0px #000000;
  //opacity: 1;
  .top {
    width: 241px;
    height: 60px;
    background-image: url('~@/assets/images/logo.png');
    position: absolute;
    z-index: 100;
    margin-top: 36px;
    margin-left: 62px;
  }
  .top-right {
    width: 552px;
    height: 41px;
    background-image: url('~@/assets/images/bigtitle.png');
    background-repeat: no-repeat;
    position: absolute;
    z-index: 100;
    margin-top: 36px;
    margin-left: 1210px;
  }
  .right-bigfloat {
    position: absolute;
    z-index: 100;
    top: 162px;
    left: 1216px;
    .bigfolat {
      width: 319px;
      height: 48px;
      background: #1d1e3c;
      box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.5);
      border-radius: 7px;
      //opacity: 0.74;
      margin-top: 5px;
      border: 0px;
      .icon {
        width: 20px;
        height: 34px;
        background-image: url('~@/assets/images/bg-title-n.png');
        margin-top: 5px;
      }
      .text {
        width: 200px;
        height: 22px;
        font-size: 16px;
        color: #ffffff;
        line-height: 33px;
        margin-top: 5px;
        margin-left: 20px;
      }
    }
  }
  .float-type {
    position: absolute;
    z-index: 100;
    top: 171px;
    left: 1601px;
    .type {
      width: 88px;
      height: 20px;
      font-size: 16px;
      color: #ffffff;
    }
    .typeButton {
      background-color: transparent;
      border: 0px solid #0091ff;
      width: 253px;
      height: 33px;
      border-radius: 5px;
      margin-top: 10px;
      .icon {
        width: 16px;
        height: 16px;
        background-image: url('../assets/images/icon-bolang.png');
        margin-top: 5px;
      }
      .text {
        height: 16px;
        font-size: 14px;
        color: #fff;
        margin-top: 5px;
        margin-left: 20px;
      }
    }
  }
  .leftData {
    width: 981px;
    height: 73px;
    background: #1d1e3c;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    //opacity: 0.74;
    position: absolute;
    top: 942px;
    left: 100px;
    z-index: 100;
    .icon {
      width: 28px;
      height: 23.69px;
      background-image: url('~@/assets/images/icon-shuju.png');
      margin-top: 20px;
      margin-left: 10px;
    }
    .shu {
      width: 2px;
      height: 37px;
      margin-left: 15px;
      background-color: #ffffff;
      margin-top: 15px;
    }
    .shijian {
      width: 60px;
      height: 73px;
      margin-left: 15px;
      color: #ffffff;
      font-size: 16px;
      line-height: 73px;
    }
    .sj-text {
      width: 170px;
      height: 73px;
      color: #ffffff;
      font-size: 14px;
      line-height: 73px;
    }
    .fengsu {
      width: 50px;
      height: 73px;
      margin-left: 15px;
      color: #ffffff;
      font-size: 16px;
      line-height: 73px;
    }
    .fs-text {
      width: 60px;
      height: 73px;
      color: #ffffff;
      font-size: 19px;
      line-height: 73px;
    }
    .fengxiang {
      width: 50px;
      height: 73px;
      margin-left: 15px;
      color: #ffffff;
      font-size: 16px;
      line-height: 73px;
    }
    .fx-text {
      width: 60px;
      height: 73px;
      color: #ffffff;
      font-size: 19px;
      line-height: 73px;
    }
    .bogao {
      width: 50px;
      height: 73px;
      margin-left: 15px;
      color: #ffffff;
      font-size: 16px;
      line-height: 73px;
    }
    .bg-text {
      width: 60px;
      height: 73px;
      color: #ffffff;
      font-size: 19px;
      line-height: 73px;
    }
    .bozhouqi {
      width: 70px;
      height: 73px;
      margin-left: 15px;
      color: #ffffff;
      font-size: 16px;
      line-height: 73px;
    }
    .bzq-text {
      width: 60px;
      height: 73px;
      color: #ffffff;
      font-size: 19px;
      line-height: 73px;
    }
    .boxiang {
      width: 50px;
      height: 73px;
      margin-left: 15px;
      color: #ffffff;
      font-size: 16px;
      line-height: 73px;
    }
    .bx-text {
      width: 60px;
      height: 73px;
      color: #ffffff;
      font-size: 19px;
      line-height: 73px;
    }
  }
  .bottom-table {
    position: absolute;
    z-index: 100;
    top: 617px;
    left: 1200px;
    width: 706px;
    height: 418px;
    background: #1d1e3c;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    //opacity: 0.74;
    .tableTop {
      .maxWind24 {
        width: 75px;
        height: 40px;
        background: #0091ff;
        border-radius: 6px;
        margin-top: 15px;
        margin-left: 24px;
        color: #ffffff;
        padding: 10px;
        .text1 {
          font-size: 14px;
          margin-left: 8px;
          margin-top: 5px;
        }
        .text2 {
          font-size: 14px;
          margin-left: 20px;
        }
      }
      .maxWind {
        margin-top: 28px;
        .text {
          width: 50px;
          height: 18px;
          font-size: 12px;
          color: #ffffff;
          margin-left: 12px;
        }
        .number {
          width: 81px;
          height: 18px;
          font-size: 14px;
          color: #ffffff;
          text-align: center;
        }
      }
      .maxFengxiang {
        margin-top: 28px;
        .text {
          width: 50px;
          height: 18px;
          font-size: 12px;
          color: #ffffff;
        }
        .number {
          width: 50px;
          height: 18px;
          font-size: 14px;
          color: #ffffff;

          text-align: center;
        }
      }
      .maxBogao24 {
        width: 75px;
        height: 40px;
        background: #0091ff;
        border-radius: 6px;
        margin-top: 15px;
        margin-left: 14px;

        color: #ffffff;
        padding: 10px;
        .text1 {
          font-size: 14px;
          margin-left: 8px;
          margin-top: 5px;
        }
        .text2 {
          font-size: 14px;
          margin-left: 20px;
        }
      }
      .maxBogao {
        margin-top: 28px;
        .text {
          width: 50px;
          height: 18px;
          font-size: 12px;
          color: #ffffff;
          margin-left: 12px;
        }
        .number {
          width: 70px;
          height: 18px;
          font-size: 14px;
          color: #ffffff;
          text-align: center;
        }
      }
      .bozhouqi {
        margin-top: 28px;
        .text {
          width: 60px;
          height: 18px;
          font-size: 12px;
          color: #ffffff;
          margin-left: 12px;
          text-align: center;
        }
        .number {
          width: 81px;
          height: 18px;
          font-size: 14px;
          color: #ffffff;
          text-align: center;
          margin-left: 2px;
        }
      }
      .boxiang {
        margin-top: 28px;
        .text {
          width: 50px;
          height: 18px;
          font-size: 12px;
          color: #ffffff;
          margin-left: 12px;
        }
        .number {
          width: 61px;
          height: 18px;
          font-size: 14px;
          color: #ffffff;
          text-align: center;
        }
      }
      .time {
        margin-top: 28px;
        .text {
          width: 50px;
          height: 18px;
          font-size: 12px;
          color: #ffffff;
          margin-left: 42px;
        }
        .number {
          width: 103px;
          height: 18px;
          font-size: 12px;
          color: #ffffff;
          text-align: center;
        }
      }
    }
  }
  .allData {
    height: 290px;
    overflow: auto;
    margin-top: 15px;
    margin-left: 20px;
    width: 660px;
    .table {
      //border-left: 1px solid #f1f1f1;
      border-top: 1px solid #f1f1f1;
      border-collapse: collapse;

      td {
        //border-right: 1px solid #f1f1f1;
        border-bottom: 1px dashed #f1f1f1;
        padding: 8px 12px;
        box-sizing: border-box;
        font-size: 12px;
      }
      .title {
        width: 706px;
        height: 33px;
        background: #292b4a;
        color: white;
        td {
          //border-right: 1px solid #f1f1f1;
          border-bottom: 1px solid #f1f1f1;
          padding: 8px 12px;
          width: 100px;
          box-sizing: border-box;
          font-size: 12px;
        }
      }
      .data {
        color: white;
        height: 33px;
      }
    }
    .table::-webkit-scrollbar {
      width: 0px;
      opacity: 0;
    }
  }
  .allData::-webkit-scrollbar {
    width: 0px;
    opacity: 0;
  }
}
</style>
